import React from "react";
import { useNavigate } from "react-router-dom";
import { getSavedUser, clearAuth } from "./lib/globalfunction";

const Header = (props) => {
  const navigate = useNavigate();
  // const isMobile = useMediaQuery("(max-width:600px)");

  function LogOut() {
    clearAuth();
    navigate("/login");
  }

  function BackToHome() {
    navigate(props.BackTo);
  }

  return (
    <div className="p-6 pt-12 glass flex justify-between items-center shrink-0 z-50">
      {props.BackTo && (
        <button
          onClick={BackToHome}
          className="p-2 bg-cyan-500/10 hover:bg-cyan-500/20 rounded-full text-cyan-400 transition-colors cursor-pointer"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M15 19l-7-7 7-7"
            ></path>
          </svg>
        </button>
      )}
      {/* 
            <div class="p-6 pt-10 flex justify-between items-center z-20 shrink-0">
                <button onclick="showScreen('home')" class="p-2 glass rounded-full hover:opacity-80 cursor-pointer"><svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path></svg></button>
                <div class="text-right">
                    <div class="font-mono text-xl text-accent" id="realtime-clock">12:00</div>
                    <div class="text-xs text-muted">LIVE SESSION</div>
                </div>
            </div> */}

      <div>
        <h2 className="font-bold text-lg">
          {process.env.REACT_APP_SITE_TITLE}
        </h2>
        <p className="text-xs text-accent">{getSavedUser()?.FacilityName}</p>
      </div>
      <div className="flex gap-2">
        {/* <button
          // onClick={toggleTheme}
          className="p-2 bg-white/5 hover:bg-white/10 rounded-full transition-colors border border-transparent hover:border-white/20 cursor-pointer"
        >
          <svg
            id="icon-sun"
            className="w-5 h-5 text-yellow-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            style={{ display: "block" }}
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            ></path>
          </svg>
          <svg
            id="icon-moon"
            className="w-5 h-5 text-slate-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            style={{ display: "none" }}
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
            ></path>
          </svg>
        </button> */}
        <button
          onClick={LogOut}
          className="p-2 bg-red-500/10 hover:bg-red-500/20 rounded-full text-red-500 transition-colors cursor-pointer"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
            ></path>
          </svg>
        </button>
      </div>
    </div>
    // <Box
    //   sx={{
    //     background: "#fff",
    //     padding: 2,
    //     px: 3,
    //     mx: "auto",
    //     /*  borderRadius: 3, */
    //     boxShadow: "0px 4px 20px rgba(0,0,0,0.08)",
    //     display: "flex",
    //     justifyContent: "space-between",
    //     alignItems: "center",
    //     maxWidth: {
    //       xs: "100%", // mobile
    //       sm: "90%", // tablets
    //       md: "50%", // desktop
    //     },
    //     minHeight: "6vh",
    //   }}
    // >
    //   <div>
    //     {props.BackTo ? (
    //       <IconButton color="success" onClick={BackToHome}>
    //         <ArrowBackIosIcon />
    //       </IconButton>
    //     ): (
    //       <IconButton sx={{pl:4}}>
    //       </IconButton>
    //     )}
    //   </div>

    //   <Box>
    //     <Typography variant="h5" fontWeight={600} sx={{ textAlign: 'center'}}>
    //       Smart Refer
    //     </Typography>

    //     <Typography
    //       fontSize={14}
    //       fontWeight={400}
    //       color="#253858"
    //       sx={{ mt: 0.5,textAlign: 'center' }}
    //     >
    //       {getSavedUser()?.FacilityName}
    //     </Typography>
    //   </Box>

    //   <IconButton color="error" onClick={LogOut}>
    //     <LogoutIcon />
    //   </IconButton>
    // </Box>
  );
};

export default Header;
